import React from 'react';
import Footer from '../components/footer';
import bg from "../assets/background.png";
import '../styles/team.modules.css';
import { useSchedule } from '../data/useLocations';
import Seo from '../components/Seo';

const SR_ONLY = {
  position: "absolute",
  width: "1px",
  height: "1px",
  padding: 0,
  margin: "-1px",
  overflow: "hidden",
  clip: "rect(0,0,0,0)",
  whiteSpace: "nowrap",
  border: 0,
};

function Team() {
  const { data, loading } = useSchedule();

  const instructors = data?.instructors || [];

  return (
    <div style={({position: "relative", display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center", minHeight: "100vh", background: `#d0142d url(${bg}) center / cover no-repeat`})}>
      <Seo
        title="Kadra instruktorska"
        description="Poznaj trenerki 4STARS - wyszkolone tancerki i instruktorki akrobatyki powietrznej prowadzące zajęcia we Wrocławiu, Jastrzębiu-Zdroju, Mszanie i okolicach"
        path="/kadra"
      />

      <h1 style={SR_ONLY}>
        Kadra instruktorska 4STARS - trenerzy tańca i akrobatyki powietrznej
      </h1>

      {!loading && instructors.length === 0 ? (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            minHeight: "60vh",
            width: "92%",
            maxWidth: "700px",
            textAlign: "center",
            fontSize: "15px",
            fontWeight: 700,
            color: "rgb(250,250,250)",
          }}
        >
          Kadrę instruktorską przedstawimy wkrótce.
        </div>
      ) : null}

      {instructors.map((i, index) => (
        index % 2 === 0 ? (
          <section
            className="teamSection_red"
            key={i.name}
            style={({display: "flex", alignItems: "center", justifyContent: "flex-start", width: "100%", gap: "20px", background: `#d0142d url(${bg}) center / cover no-repeat`, marginTop: index === 0 ? "60px" : "0px"})}
          >
            {i.photoUrl ? (
              <img
                src={i.photoUrl}
                alt={i.profession ? `${i.name} - ${i.profession}` : i.name}
                loading="lazy"
              />
            ) : null}
            <div style={({display: "flex", flexDirection: "column", justifyContent: "flex-start"})}>
              <h2 style={({color: "rgb(250,250,250)", fontWeight: "bold"})}>{i.name}</h2>
              {i.profession ? (
                <h3 style={({color: "rgb(250,250,250)", marginTop: "-18px"})}>{i.profession}</h3>
              ) : null}
              {i.description ? (
                <h4 style={({color: "rgb(250,250,250)", fontWeight: "normal", whiteSpace: "pre-line"})}>{i.description}</h4>
              ) : null}
            </div>
          </section>
        ) : (
          <section
            className="teamSection_white"
            key={i.name}
            style={({display: "flex", alignItems: "center", justifyContent: "flex-start", width: "100%", gap: "20px", background: `#ededed url(${bg}) center / cover no-repeat`, marginTop: index === 0 ? "40px" : "0px"})}
          >
            {i.photoUrl ? (
              <img
                src={i.photoUrl}
                alt={i.profession ? `${i.name} - ${i.profession}` : i.name}
                loading="lazy"
              />
            ) : null}
            <div style={({display: "flex", flexDirection: "column", justifyContent: "flex-start"})}>
              <h2 style={({color: "rgb(0,0,0)", fontWeight: "bold"})}>{i.name}</h2>
              {i.profession ? (
                <h3 style={({color: "rgb(0,0,0)", marginTop: "-18px"})}>{i.profession}</h3>
              ) : null}
              {i.description ? (
                <h4 style={({color: "rgb(0,0,0)", fontWeight: "normal", whiteSpace: "pre-line"})}>{i.description}</h4>
              ) : null}
            </div>
          </section>
        )
      ))}

      <Footer />
    </div>
  );
}

export default Team;